import { render, staticRenderFns } from "./communityIssueFg.vue?vue&type=template&id=103f3724&scoped=true&"
import script from "./communityIssueFg.vue?vue&type=script&lang=js&"
export * from "./communityIssueFg.vue?vue&type=script&lang=js&"
import style0 from "./communityIssueFg.vue?vue&type=style&index=0&id=103f3724&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103f3724",
  null
  
)

export default component.exports